import React from 'react';
import {
    Box,
    Dialog,
} from '@mui/material';
import ArticleViewBody from './ArticleViewBody';

export default function BodyCompareDialog({ open, onClose, originalBody }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen
            PaperProps={{
                sx: {
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    px: { xs: 1, sm: 2 },
                    py: { xs: 1, sm: 2 },
                    bgcolor: 'background.default',
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 1400,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        bgcolor: 'background.paper',
                        overflow: 'hidden',
                    }}
                >
                    <Box sx={{ flex: 1, minHeight: 0, px: { xs: 1.5, sm: 3 }, pb: { xs: 1.5, sm: 3 } }}>
                        <ArticleViewBody compareLayout originalBody={originalBody} onBack={onClose} />
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
}
